export default {"src":"/_next/static/media/deutschland-test-seal.f49ab6dc.svg","height":119,"width":156,"blurWidth":0,"blurHeight":0};